import getParams from './params';
import * as authentication from './authentication';
import * as pubsub from './pubsub';
import style from './style';


export const setAddress = (data, el) => {
  // const exp = /(\d{1}(\w{1})?)+\-?((\d{1}(\w{1})?)+)?/;
  const newData = Object.assign({}, data);
  const zipcode = el.getAttribute('data-getnet-customer-address-zipcode')
    ? el.getAttribute('data-getnet-customer-address-zipcode')
            .replace(/^s+|s+$/g, '')
            .replace('.', '')
            .replace('-', '')
            : '';
   // : '00000000';

  // zipcode = `${zipcode.substr(0, 5)}-${zipcode.substr(5, 3)}`;
  // if (!exp.test(zipcode))zipcode = '';
  newData.customerAddressZipcode = zipcode;
  return newData;
};

export const setStyle = (styles) => {
  const sheet = document.createElement('style');
  sheet.innerHTML = styles;
  document.head.appendChild(sheet);
};

export const removeLoading = (bodyContent) => {
  const el = document.getElementById('getnet-loader');
  if (el) bodyContent.removeChild(el);
};

export const hideModal = (bodyContent, ifrm) => {
  bodyContent.setAttribute('style', 'position: relative');
  ifrm.setAttribute('style', 'display: none;');
};

export const messageListener = (ifrm, bodyContent, params, events) => {
  const button = document.querySelector('[data-getnet-sellerid]');
  let btn;
  if (button) {
    const buttonClass = button.getAttribute('data-getnet-button-class');
    btn = document.querySelector(`.${buttonClass}`);
  }

  window.getNetMessageLoader = (e) => {
     /* istanbul ignore if */
    if (e.data === 'loaded') {
      bodyContent.setAttribute('style', 'position: fixed');
      removeLoading(bodyContent);
        /* istanbul ignore if */
    } else if (e.data === 'close') {
      hideModal(bodyContent, ifrm);
      // eslint-disable-next-line
      btn.removeEventListener('click', open, false);
      pubsub.publish('close', '');
      /* istanbul ignore if */
    } else if (e.data.status === 'error') {
      /* istanbul ignore if */
      pubsub.publish(e.data.status, e.data.detail);
    } else if (e.data.status === 'pending') {
      /* istanbul ignore if */
      pubsub.publish('pending', e.data.detail);
      /* istanbul ignore if */
    } else if ((e.data === 'success' || e.data.status === 'success')) {
      /* istanbul ignore if */
      pubsub.publish('success', '');
      if(params.urlCallback !== null && params.urlCallback.trim() !== "") {
      	setTimeout(() => {
          window.location = params.urlCallback;
        }, 3000);
      }
      /* istanbul ignore if */
    } else if (Array.isArray(e.data) && e.data.indexOf('tmx_profiling_complete') !== -1) {
      /* istanbul ignore if
      ) && ereturn false;
      /* istanbul ignore else */
    }
  };

  window.addEventListener('message', window.getNetMessageLoader, false);
};

export const createModal = (bodyContent, params, redirect, events = pubsub) => {
  const checkout = document.querySelector('#getnet-checkout') || '';
  const loading = document.createElement('div');

  loading.setAttribute('id', 'getnet-loader');
  bodyContent.appendChild(loading);

  if (!checkout) {
    const modal = document.createElement('iframe');

    modal.setAttribute('src', redirect);
    modal.setAttribute('id', 'getnet-checkout');
    bodyContent.appendChild(modal);
  } else {
    checkout.src = redirect;
  }

  const time = setInterval(() => {
    const ifrm = document.querySelector('#getnet-checkout');

    if (ifrm) {
      ifrm.onload = () => {
        ifrm.contentWindow.postMessage(params, redirect);
        ifrm.setAttribute('style', 'display: block;');
        messageListener(ifrm, bodyContent, params, events);
        clearInterval(time);
      };
    }
  }, 150);
};

export const open = () => {
  if (window.getNetMessageLoader) {
    window.removeEventListener('message', window.getNetMessageLoader, false);
  }

  const script = document.querySelector('[data-getnet-sellerid]');

  let params = getParams(script);
  params = setAddress(params, script);

  const isValid = authentication.authenticationItems(params);
  if (!isValid) return false;

  const bodyContent = document.getElementsByTagName('body')[0];
  return createModal(bodyContent, params, process.env.REMOTE_PATH);
};

export const createListeners = (buttonClass, doc = document, events = pubsub) => {
  events.subscribe('open', open);

  if (buttonClass) {
    const btn = doc.querySelector(`.${buttonClass}`);
    return btn && btn.addEventListener('click', open, false);
  }

  return false;
};

export const initialize = () => {
  /* istanbul ignore next */
  const buttonClass = document.querySelector('[data-getnet-sellerid]').getAttribute('data-getnet-button-class');
  window.getnet = Object.assign({}, pubsub);
  setStyle(style);
  createListeners(buttonClass);

  return true;
};



// WEBPACK FOOTER //
// ./src/methods.js